/* eslint-disable react/require-default-props */
import React from 'react';
import error_icon from 'assets/images/icon-edital-erro.svg';

type LoadingBiddingProps = {
  title?: string;
  subtitle?: string;
};

const BiddingNoContentError: React.FC<LoadingBiddingProps> = ({ title, subtitle }) => {
  return (
    <div className="text-center">
      <img alt="icone de mensagem de erro" src={error_icon} className="m-auto" />
      <div className="mt-3 d-flex flex-column align-items-center">
        <h5 className="font-weight-bold w-75">{title}</h5>
        <p className="mb-0">{subtitle}</p>
      </div>
    </div>
  );
};

export default BiddingNoContentError;
